import React, {Component} from "react"
import 'datatables.net'
import 'datatables.net-bs'
import 'datatables.net-responsive'
import 'datatables.net-bs/css/dataTables.bootstrap.css'
import ReactDOM from "react-dom"
import Button from "../../../components/Button"
import {convertToDisplayFormat, formatDateInReport, parse} from "../../../util/DateUtil"
import {injectIntl} from "react-intl"
import {calibrationStatusMap, COGOLAND_SESSION_DATE_FORMAT, DATE_CHART_FORMAT} from "../../../constants"
import {getDataTablesLang} from "../../../lang/datatables"
import {Badge} from "react-bootstrap"

const tableId = 'UsersWithStatusTable'


const usersToTableData = (users) => {

  return users.map((user) => {
    const status = user.status || {
      currentIndex: '',
      remainingSessions: '',
      completedSessions: '',
      dueSessions: '',
      completedToday: '',
      startDate: undefined,
      completionDate: undefined,
    }

    return [
      user.name,
      status.currentIndex,
      status.remainingSessions,
      status.completedSessions,
      status.dueSessions,
      status.completedToday,
      status.startDate,
      status.completionDate,
      user.calibrationStatus || 'NONE',
      user
    ]
  })
}

const renderTable = (users, onSelect, format, intl) => {

  const locale = format({id: 'system.current.locale'})
  const language = getDataTablesLang(locale)

  const data = usersToTableData(users)
  const buildDateColumnDef = index => {
    return {
      "targets": index,
      "data": (row, type, set, meta) => {

        if (type === 'sort') {
          return row[index] || ''
        } else return row

      },
      "createdCell": function (td, data, rowData, row, col) {
        const dateStr = data[index]
        const component = <div>{dateStr ? convertToDisplayFormat(dateStr, COGOLAND_SESSION_DATE_FORMAT) : '-'}</div>
        ReactDOM.render(component, td)
      }
    }
  }

  $(`#${tableId}`).DataTable({
    language,
    data,
    responsive: true,
    "order": [[0, 'asc']],
    "columnDefs": [
      buildDateColumnDef(7),
      buildDateColumnDef(6),
      {

        "targets": 4,
        "data": null,
        "visible": true,
        "createdCell": function (td, data, rowData, row, col) {

          const dueSessions = data[4]
          const remainingSessions = data[2]

          const component = remainingSessions === 0 ?
            <Badge pill bsStyle={'break'}>{format({id: 'completed'})}</Badge>
            : dueSessions > 0 ?
              <Badge pill bsStyle={'due'}>{format({id: 'overdue'})}</Badge>
              : dueSessions === 0 ?
                <Badge pill bsStyle={'completed'}>{format({id: 'on.schedule'})}</Badge>
                :
                <div/>
          ReactDOM.render(component, td)
        }
      },
      {

        "targets": 5,
        "data": null,
        "visible": false,
        "createdCell": function (td, data, rowData, row, col) {

          const completedToday = data[5]

          const component = completedToday > 0 ?
            <div className="text-center">
              <i className="fa fa-check fa-2x" style={{color: 'green'}}/>
            </div>
            : <div></div>
          ReactDOM.render(component, td)
        }
      },
      {

        "targets": 8,
        "data": null,
        "createdCell": function (td, data, rowData, row, col) {

          const status = data[8]

          const component = (
            <div>{format({id: `calibration.status.${status}`})}</div>
          )
          ReactDOM.render(component, td)
        }
      },
      {

        "targets": 9,
        "data": null,
        "createdCell": function (td, data, rowData, row, col) {

          const user = data[9]

          const component = (
            <Button onClick={() => {
              if (onSelect) onSelect(user.id)
            }}>
              {format({id: 'cogoland.button.view'})}
            </Button>
          )
          ReactDOM.render(component, td)
        }
      }
    ]
  });
}

const updateTable = (users) => {
  const data = usersToTableData(users)
  $(`#${tableId}`).DataTable().clear()
  $(`#${tableId}`).DataTable().rows.add(data).draw()
}

class UsersWithStatusTable extends Component {

  componentDidMount() {

    const intl = this.props.intl
    const format = intl.formatMessage

    renderTable(this.props.data, this.props.onSelect, format, intl)
  }

  componentWillReceiveProps(nextProps) {
    updateTable(nextProps.data)

  }

  render() {
    const intl = this.props.intl
    const format = intl.formatMessage

    return (
      <table width="100%" className="table table-striped table-bordered table-hover dataTables-example" id={tableId}>
        <thead>
        <tr>
          <th>{format({id: 'name'})}</th>
          <th>{format({id: 'current.active.session'})}</th>
          <th>{format({id: 'sessions.remaining'})}</th>
          <th>{format({id: 'sessions.completed'})}</th>
          <th>{format({id: 'due'})}</th>
          <th>{format({id: 'completed.today'})}</th>
          <th>{format({id: 'cogoland.report.programme.start.date'})}</th>
          <th>{format({id: 'cogoland.report.programme.end.date'})}</th>
          <th>{format({id: 'calibration.status'})}</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        </tbody>
      </table>
    )
  }
}

export default injectIntl(UsersWithStatusTable)



// WEBPACK FOOTER //
// ./src/routes/cogoland/component/UsersWithStatusTable.js